import * as types from "./action-types";
import { errorHandler } from "../../../../utils/errors";
import NotificationApi from "../../../../api/NotificationApi";

/**export const deleteNotification = data => ({
	type: types.DELETE_NOTIFICATION,
	payload: NotificationApi.deleteNotification(data)
});**/

export const deleteNotification = data => {
	console.log(data);
	return dispatch => {
		return dispatch({
			type: types.DELETE_NOTIFICATION,
			payload: NotificationApi.deleteNotification(
				data
			).then(({ data }) => {
				Promise.all([
					dispatch(getNotifications()),
					dispatch(updateInsightNotifications())
				]);
			})
		});
	};
};

export const getNotifications = () => ({
	type: types.GET_ALL_NOTIFICATIONS,
	payload: NotificationApi.getAllNotifications()
});

export const updateInsightNotifications = () => ({
	type: types.UPDATE_INSIGHTS_AFTER_GLOBAL_NOTIFICATION_DELETE
});

export const gridAction = (data, actionInfo) => {
	return dispatch => {
		return dispatch({
			type: types.NOTIFICATION_SUBITEM_DELETE,
			payload: NotificationApi.gridAction(
				data,
				actionInfo
			).then(({ data }) => {
				Promise.all([
					dispatch(getNotifications()),
					dispatch(updateInsightNotifications())
				]);
			})
		});
	};
};

// Fetch notification detail
export const fetchNotificationDetail = reportParams => ({
	type: types.FETCH_NOTIFICATION_DETAILS_GLOBAL,
	payload: NotificationApi.getNotificationDetail(reportParams)
});

export const drillDown = ({ navTitle, drillDownData }) => ({
	type: types.NOTIFICATION_DRILL_DOWN,
	navTitle,
	drillDownData
});

export const drillUp = () => ({
	type: types.NOTIFICATION_DRILL_UP
});

export const fetchSummaryDetails = ({ FetchParams, navTitle }) => ({
	type: types.FETCH_NOTIFICATION_SUMMARY_DETAILS,
	payload: NotificationApi.getSummaryDetail(FetchParams),
	meta: { FetchParams, navTitle }
});

/** Fetch Total till date by key **/
export const fetchTotalTillDateByKey = (
	graphId,
	companyCode,
	countryCode,
	filterKeyId
) => ({
	type: types.NOTIFICATION_FETCH_DETAIL_TOTAL_TILL_DATE,
	payload: NotificationApi.getTotalTillDateByKey(
		graphId,
		companyCode,
		countryCode,
		filterKeyId
	)
});



// WEBPACK FOOTER //
// ./src/features/common/GlobalNotification/actions/index.js